// eslint-disable-next-line import/no-cycle
import Vue from 'vue';
import Vuex from 'vuex';
// eslint-disable-next-line import/no-cycle
import { apiGetAppUserinfo, apiGetUserInfo } from '@/api/common';
// eslint-disable-next-line import/no-cycle
import { nickNamefilter } from '@/assets/utils/utils';
import router from '../router';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // 是否是微医路由
    appRoute: true,
    // im是否登录发言
    isImLogin: false,
    // 加载中,显示进度条
    isVideoLoading: true,
    // 聊天群组id
    groupId: '',
    userInfo: {},
    x5videoenterfullscreen: false,
    keepAliveComponents: [],
    isShowShopping: false,
    isShowLiveWXshare: false,
    // 区分微医APP和H5
    sourceId: '',
    channel: '',
  },
  mutations: {
    changeSeting: (state, { key, value }) => {
      // eslint-disable-next-line no-prototype-builtins
      if (state.hasOwnProperty(key)) {
        state[key] = value;
      }
    },
    keepAlive(state, component) {
      // 注：防止重复添加（当然也可以使用Set）
      // eslint-disable-next-line no-unused-expressions
      !state.keepAliveComponents.includes(component) && state.keepAliveComponents.push(component);
    },
    noKeepAlive(state, component) {
      const index = state.keepAliveComponents.indexOf(component);
      // eslint-disable-next-line no-unused-expressions
      index !== -1 && state.keepAliveComponents.splice(index, 1);
    },
  },
  actions: {
    async getUserInfo({ commit }, { userId, form, type }) {
      let res;
      commit('changeSeting', { key: 'userInfo', value: {} });
      const errFun = err => {
        if (err.code === 202) {
          let typeUrl = 'video';
          if (router.currentRoute.name === 'userCenter') {
            typeUrl = 'user';
          }
          const url = `${window.location.protocol}//${window.location.host}/nouser?type=${typeUrl}&form=${form}`;
          window.location.replace(url);
        }
      };
      if (type === 'expert') {
        res = await apiGetAppUserinfo({ userId }).catch(err => {
          errFun(err);
        });
      } else {
        res = await apiGetUserInfo({ userId }).catch(err => {
          errFun(err);
        });
      }

      if (res && res.data) {
        const nickName = String(res.data.nickName);
        res.data.nickName = nickNamefilter(nickName);
        commit('changeSeting', { key: 'userInfo', value: res.data });
      }
    },
  },
  modules: {},
});
